import { render, staticRenderFns } from "./mocImprTab.vue?vue&type=template&id=696a7cfb"
import script from "./mocImprTab.vue?vue&type=script&lang=js"
export * from "./mocImprTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696a7cfb')) {
      api.createRecord('696a7cfb', component.options)
    } else {
      api.reload('696a7cfb', component.options)
    }
    module.hot.accept("./mocImprTab.vue?vue&type=template&id=696a7cfb", function () {
      api.rerender('696a7cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/moc/mocImprTab.vue"
export default component.exports